<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g fill="currentColor">
    <path d="M0.936524 12.3379L2.14989 13.5L8.93652 7L2.14989 0.5L0.936523 1.66212L6.50979 7L0.936524 12.3379Z" fill="#15284C"/>
  </g>
</svg>
